@if (usedBooks && usedBooks.length > 0) {
    <h4>Zuletzt verwendete Bücher</h4>
    <div class="edition-switcher-used-books">
        <ul class="used-books">
            @for (usedBook of usedBooks; track usedBook) {
                <li>
                    <a [attr.href]="usedBook.link" [attr.title]="usedBook.name" data-bs-placement="right" data-bs-toggle="tooltip"
                       data-bs-trigger="hover" target="_blank">
                        <img [alt]="'Cover von ' + usedBook.name" src="{{ usedBook.thumbnailCover.url }}"/>
                    </a>
                </li>
            }
        </ul>
    </div>
}